import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflow: 'hidden',
    // ...theme.scrollbarStyles,
    // background:
    //   theme.palette.type === 'dark'
    //     ? `url(${bgFlowDark}) repeat`
    //     : `url(${bgFlowLight}) repeat`,
    // backgroundSize: `url(${bgFlow}) repeat ` ,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    opacity: 1
  },
  cardDepartment: {
    border:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    borderRadius: 16,
    padding: 24,
    margin: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  boxButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8
  },
  iconButtonDelete: {
    color: theme.palette.red_100.main,
    backgroundColor: 'transparent',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.red_100.main,
      color: theme.palette.white_100.main
    }
  },
  optionsGrid: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'nowrap',
    margin: '50px 90px'
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}))
